var map = {
	"./staging_apply_discount_fallback.json": [
		90824,
		824
	],
	"./staging_new_h_2_fallback.json": [
		50258,
		258
	],
	"./staging_new_h_fallback.json": [
		90221,
		221
	],
	"./staging_new_t_fallback.json": [
		25498,
		5498
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 73856;
module.exports = webpackAsyncContext;